import { observer } from 'mobx-react-lite';
import { AirportItem } from './AirportItem';
import { useEffect, useRef } from 'react';
import { DATA } from '../../../../game/data';
import { UpgradeInfoTable } from '../../UpgradeInfoTable';
import { AIRPORT_DATA, AIRPORT_UPGRADES } from '../../../../game/data/airportData';

export const AirportSidebar: React.FC = observer(() => {
  const scrollIntoViewSlug = DATA.sidebarData.highlightedAirportSlug;
  const highlightedRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (highlightedRef.current) {
      highlightedRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [scrollIntoViewSlug]);

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16, marginBottom: 24 }}>
        {DATA.airports
          .filter((a) => a.isAvaialbleForPurchase)
          .map((airport) => {
            const isHighlighted = airport.slug === scrollIntoViewSlug;
            return (
              <div key={airport.slug} ref={isHighlighted ? highlightedRef : null}>
                <AirportItem airport={airport} highlight={isHighlighted} />
              </div>
            );
          })}
      </div>
      <div style={{ marginBottom: 8 }}>
        <div className="tooltip-text">Transport a minimum number of passengers to unlock new airports.</div>
        <UpgradeInfoTable upgrades={Object.values(AIRPORT_UPGRADES)} />
      </div>
    </>
  );
});
